import { render, staticRenderFns } from "./developStandard.vue?vue&type=template&id=12823337&scoped=true"
import script from "./developStandard.vue?vue&type=script&lang=js"
export * from "./developStandard.vue?vue&type=script&lang=js"
import style0 from "./developStandard.vue?vue&type=style&index=0&id=12823337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12823337",
  null
  
)

export default component.exports